<template>
    <div class="app-wrapper">
      <ResponsiveNavbar />
      <main class="main-content">
        <ResponsiveHeader />
        <ResponsiveKaarten />
        <ResponsiveAbout />
        <ContactUs />
      </main>
      <Footer />
    </div>
  </template>
  
  <script>
import ResponsiveNavbar from '../components/Navbar.vue';
import ResponsiveHeader from '../components/Header.vue';
import ResponsiveKaarten from '../components/Kaarten.vue';
import ResponsiveAbout from '../components/About.vue';
import ContactUs from '../components/ContactUs.vue';
import Footer from '../components/Footer.vue';

  
  export default {
    name: "HomePage",
    components: {
      ResponsiveNavbar,
      ResponsiveHeader,
      ResponsiveKaarten,
      ResponsiveAbout,
      ContactUs,
      Footer,
    },
    methods: {
      goToAssortiment() {
        this.$router.push('/assortiment');
      },
    },
  };
  </script>
  
  <style>
  </style>
  